import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter } from 'lucide-react';


const Footer = () => {
  return (
    <footer className="bg-primary text-white pt-12 pb-6">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1">
          <div className="flex items-center space-x-2">
  <img
    src="/logobeyaz.png"
    alt="Logo"
    className="w-10 h-10 object-contain"
  />
  <span className="font-semibold text-lg">Çelik Ticaret</span>
</div>  
            <p className="mt-4 text-sm opacity-90">
              Kaliteli ürünlerimiz ile hizmetinizdeyiz. Değerlerinizi en güzel şekilde yansıtan ürünler için doğru adres.
            </p>
            <div className="mt-6 flex space-x-4">
              <a href="https://facebook.com" className="text-white hover:text-secondary-light transition-colors" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="https://www.instagram.com/celiktuhafiyeafyon/" className="text-white hover:text-secondary-light transition-colors" aria-label="Instagram">
                <Instagram size={20} />
              </a>
              <a href="https://twitter.com" className="text-white hover:text-secondary-light transition-colors" aria-label="Twitter">
                <Twitter size={20} />
              </a>
            </div>
          </div>

          <div className="col-span-2">
  <h3 className="text-lg font-semibold mb-4">Bağlantılar</h3>
  <ul className="grid grid-cols-2 gap-x-4 gap-y-2">
    <li>
      <Link to="/" className="text-sm opacity-90 hover:opacity-100 transition-opacity">
        Ana Sayfa
      </Link>
    </li>
    <li>
      <Link to="/kvkk" className="text-sm opacity-90 hover:opacity-100 transition-opacity">
        KVKK
      </Link>
    </li>
    <li>
      <Link to="/contact" className="text-sm opacity-90 hover:opacity-100 transition-opacity">
        İletişim
      </Link>
    </li>
    <li>
      <Link to="/mesafeli-satis-sozlesmesi" className="text-sm opacity-90 hover:opacity-100 transition-opacity">
        Mesafeli Satış Sözleşmesi
      </Link>
    </li>
    <li>
      <Link to="/kargo-sureci" className="text-sm opacity-90 hover:opacity-100 transition-opacity">
        Kargo Süreci
      </Link>
    </li>
    <li>
      <Link to="/uyelik-sozlesmesi" className="text-sm opacity-90 hover:opacity-100 transition-opacity">
        Üyelik Sözleşmesi
      </Link>
    </li>
  </ul>
</div>

            
         

          <div className="col-span-1">
            <h3 className="text-lg font-semibold mb-4">İletişim</h3>
            <address className="not-italic text-sm">
              <p className="mb-2 opacity-90">Akmescit, Terakki Sk NO:3/A, 03200 Merkez/Afyonkarahisar</p>
              <p className="mb-2 opacity-90">+90 0542 893 07 19</p>
              <p className="opacity-90">selimcelikafyon@gmail.com</p>
            </address>
          </div>
        </div>

        <div className="border-t border-white/20 mt-10 pt-6">
          <p className="text-center text-sm opacity-80">
            &copy; {new Date().getFullYear()} Çelik Ticaret. Tüm Hakları Saklıdır.
          </p>
          <p className="text-center text-xs opacity-40">
          Made By <a 
  href="https://www.instagram.com/lumine.xweb/" 
  target="_blank" 
  rel="noopener noreferrer"
  
>
  Luminex Design
</a>
          </p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;